(function(angular){
	'use strict';

	angular
		.module('recurringInvestmentModule')
		.controller('RecurringInvestmentSettingsLanding', [
			'$scope',
			'APP_BASE_PATH',
			'SettingsFactory',
			'urlFactory',
			RecurringInvestmentFunction
		]);

	function RecurringInvestmentFunction(
		$scope,
		APP_BASE_PATH,
		SettingsFactory,
		urlFactory
	){
		var recurringInvestment = this;

		recurringInvestment.$onInit = function () {
			SettingsFactory.recurringInvestment.get()
				.then(function(activeSchedule) {
					if(angular.isDefined(activeSchedule)) {
						recurringInvestment.schedule = activeSchedule;
						recurringInvestment.buttonMeta = {
							label: 'Update Settings',
							url: 'manage'
						};
					} else {
						recurringInvestment.buttonMeta = {
							label: 'Enable',
							url: APP_BASE_PATH + '/account/recurring-investment/new?backLink=settings'
						};
					}
					recurringInvestment.loaded = true;
				});
		};

		recurringInvestment.openConfirmationModal = function() {
			if(!recurringInvestment.submitted) {
				$scope.$broadcast('confirmationModal:open');
			}
		};

		recurringInvestment.handleDelete = function() {
			SettingsFactory.recurringInvestment.delete()
				.then(function(successUrl) {
					urlFactory.redirect(successUrl);
				});
		};
	}
})(window.angular);